import React, { Component } from 'react';
import Login from './Login';
import { isLoggedIn } from './TokenManager';
import config from "../../config";
import Register from './Register';
import ForgotPassword from './ForgotPassword';
import ResetPassword from './ResetPassword';
import ForgotPasswordPage from './ForgotPasswordPage';
import { withTranslationProvider } from '../Common/Translations';
import { removeState } from "../Common/localStorage";

export { Login, Register, ForgotPassword, ResetPassword, ForgotPasswordPage };

class Auth extends Component {
    constructor(props) {
        super(props);
        const {
          formState = 'login'
        } = this.props;

        this.state = { formState };
        this._updateFormState = this._updateFormState.bind(this);
        this._updateTokenAndCloseModal = this._updateTokenAndCloseModal.bind(this);
    }

    _updateFormState(formState) {
      this.setState({formState: formState});
    }

    _updateTokenAndCloseModal(token) {
        const {
          onTokenUpdate,
          tRoute
        } = this.props;
        this.props.closeModal();
        if(typeof onTokenUpdate === "function") {
          return onTokenUpdate();
        }
        //@todo
        // For cases where uses logged out, and logged in as another user,
        // We kind of only fetch information on componentDidMount in a lot of components
        // Hence a full page refresh is the most effective way to clear the React state.
        window.location = tRoute('/account/dashboard/order');
    }

    render() {
      const {
        closeModal,
        isFromEditor = false,
      } = this.props;
      let Comp = ForgotPassword;

      if(this.state.formState == 'login'){
        Comp = Login;
      }
      else if(this.state.formState == 'register'){
        Comp = Register;
      }

      return (<div>{
        <Comp updateFormState={this._updateFormState}
              closeModal={closeModal}
              updateToken={this._updateTokenAndCloseModal}
              isFromEditor={isFromEditor}/>
      }</div>)
    }
}

export default withTranslationProvider(Auth);

export const willRequireLogin = (WrappedComponent) => {
  return (props) => {
    if (!isLoggedIn()) {
      return (
        <Auth
          onTokenUpdate={() => {
            window.location.reload();
          }}
          closeModal={() => {}} />
      );
    };

    return <WrappedComponent {...props}/>;
  };
}

export const logout = () => {
    return $.get(config.api + '/logout',
        (response) => {
            removeState('access_token');
            removeState('UserDetail');
            window.location.assign('/');
        }
    ).fail((response) => {
        if ('string' === typeof response.responseJSON.errors) {
            toastr.error(
                response.responseJSON.errors, '',
                {"positionClass": "toast-bottom-full-width"}
            );
        } else {
            Object.keys(response.responseJSON.errors).map(x => {
                toastr.error(
                    response.responseJSON.errors[x], '',
                    {"positionClass": "toast-bottom-full-width"}
                );
            });
        }
    });
}



// WEBPACK FOOTER //
// ./src/Auth/index.js